import React from "react";
import { useLang } from "../../context/LanguageContext";
import { t } from "../../data/translations";

const Marquee = () => {
    const { lang } = useLang();
    const items = t.marquee.items[lang];
    // duplicate for seamless loop
    const list = [...items, ...items, ...items, ...items];
    return (
        <div className="bg-gradient-to-r from-amber-50 via-white to-amber-50 border-y border-amber-200/60 overflow-hidden">
            <div className="flex items-center max-w-full">
                <div className="shrink-0 bg-red-700 text-white text-xs sm:text-sm font-bold px-3 sm:px-4 py-2 uppercase tracking-widest">
                    <i className="fa-solid fa-bullhorn mr-2" />
                    {lang === "mr" ? "जाहीर सूचना" : "Announcements"}
                </div>
                <div className="relative flex-1 overflow-hidden">
                    <div className="flex animate-marquee whitespace-nowrap py-2">
                        {list.map((it, idx) => (
                            <span
                                key={idx}
                                className="mx-6 sm:mx-10 text-sm sm:text-[15px] font-semibold text-red-800 inline-flex items-center gap-3"
                            >
                                <i className="fa-solid fa-star text-amber-500 text-xs" />
                                {it}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Marquee;
